import { render, staticRenderFns } from "./StocksTable.vue?vue&type=template&id=72126bf2&scoped=true"
import script from "./StocksTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./StocksTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StocksTable.vue?vue&type=style&index=0&id=72126bf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72126bf2",
  null
  
)

export default component.exports